export const SET_CAROUSEL_SLIDES = 'setCarouselSlides';
export const TRY_FETCH_CAROUSEL_SLIDES = 'tryFetchCarouselSlides';
